import { Component, Input } from '@angular/core';
import { colors } from 'src/app/colors';
import { ProjectService } from 'src/app/Services/project.service';

@Component({
  selector: 'progressbar',
  templateUrl: './application-usage-progressbar.component.html',
  styleUrls: ['./application-usage-progressbar.component.css'],
  standalone: false
})
export class ApplicationUSageProgressbarComponent {
  @Input("data") data: any;
  @Input("isDashboard") isDashboard: any;
  @Input("displayForWebsiteUsageChart") displayForWebsiteUsageChart: any = [];
  @Input("display") display: any = [];
  @Input("ArrFirstLabelsWebsiteUsageChart") ArrFirstLabelsWebsiteUsageChart: any = [];
  @Input("labels") ArrFirstlabels: any = [];
  @Input("ArrSecondLabelsWebsiteUsageChart") ArrSecondLabelsWebsiteUsageChart: any = [];
  @Input("labels") ArrSecondlabels: any = [];
  @Input("isDataWebsiteUsage") isDataWebsiteUsage: Boolean;
  @Input("chartdata") chartdata: any = [];
  @Input("chartDataForWebsiteUsage") chartDataForWebsiteUsage: any;
  @Input("starDate") starDate: any;
  @Input("endDate") endDate: any;
  @Input("starDateWebsiteUsage") starDateWebsiteUsage: any;
  @Input("endDateWebsiteUsage") endDateWebsiteUsage: any;
  @Input("gridTemplate") gridTemplate: Boolean;
  @Input("grid") grid: Boolean;
  // time = ['20%','30%','40%','20%','30%','40%','20%','30%','50%','40%']
  listShowingLength = 5;
  maxTime: string = "00:00:00";
  maxTimeWebsiteUsage: string = "00:00:00";
  BarColor = colors.BarColor
  BarColor1 = colors.BarColor1;
  BarColor2 = colors.BarColor2;

  applicationData: any = {
    appName: "Google Chrome",
    usersApplication: [
      {
        user: "Dhrumil Gandhi",
        applicationUsage: "10:00:00"
      },
      {
        user: "Keval Vala",
        applicationUsage: "09:00:00"
      },
      {
        user: "Ashish Paramar",
        applicationUsage: "06:00:00"
      },
      {
        user: "Rinku Mam",
        applicationUsage: "02:00:00"
      },
    ]
  }
  constructor(private _projectService: ProjectService) {
    this._projectService.ApplicationUSage.subscribe((value: any) => {
      this.chartdata = value.data;
      this.starDate = value.start_date;
      this.endDate = value.end_date;
      if (value.display) {
        this.display = value.display;
        this.maxTime = this.getTotalTime(value.data) || "00:00:00";
        this.display.forEach(item => {
          item.usagePercentage = this.timeToPercentage(item.usageTime, this.maxTime);
        });

        if (value.display.length >= 4) {
          this.ArrFirstlabels = this.display.slice(0, 5);
          this.ArrSecondlabels = this.display.slice(5, 10);
        } else {
          this.ArrFirstlabels = this.display;
          this.ArrSecondlabels = [];
        }
      } else {
        this.display = [];
        this.ArrSecondlabels = [];
        this.ArrFirstlabels = [];
      }
    });

    this._projectService.webSiteUsage.subscribe((value: any) => {
      this.chartDataForWebsiteUsage = value.data;
      this.starDateWebsiteUsage = value.start_date;
      this.endDateWebsiteUsage = value.end_date;
      if (value.display) {
        this.displayForWebsiteUsageChart = value.display;
        this.maxTimeWebsiteUsage = this.getTotalTime(value.data) || "00:00:00";
        this.displayForWebsiteUsageChart.forEach(item => {
          item.usagePercentage = this.timeToPercentage(item.usageTime, this.maxTimeWebsiteUsage);
        });

        if (value.display.length >= 4) {
          this.ArrFirstLabelsWebsiteUsageChart = this.displayForWebsiteUsageChart.slice(0, 5);
          this.ArrSecondLabelsWebsiteUsageChart = this.displayForWebsiteUsageChart.slice(5, 10);
        } else {
          this.ArrFirstLabelsWebsiteUsageChart = this.displayForWebsiteUsageChart;
          this.ArrSecondLabelsWebsiteUsageChart = [];
        }
      } else {
        this.displayForWebsiteUsageChart = [];
        this.ArrFirstLabelsWebsiteUsageChart = [];
        this.ArrSecondLabelsWebsiteUsageChart = [];
      }
    });
  }

  timeToMilliseconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalMilliseconds = (hours * 3600 + minutes * 60 + seconds) * 1000;
    return totalMilliseconds;
  }

  timeToDecimalHours(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return (hours + minutes / 60 + seconds / 3600).toFixed(2);
  }

  timeToHours(timestr) {
    if (!timestr) return '00:00 h';
    const [hours, minutes, seconds] = timestr.split(":").map(Number);
    return `${this.padZeroes(hours)}:${this.padZeroes(minutes)}` + ' h';
  }

  timeToPercentage(timeString, maxTime) {
    if (!maxTime || maxTime === "00:00:00" || !timeString) {
      return "0%";
    }
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    const [maxHours, maxMinutes, maxSeconds] = maxTime.split(':').map(Number);
    const maxTotalSeconds = maxHours * 3600 + maxMinutes * 60 + maxSeconds;

    if (maxTotalSeconds === 0) {
      return "0%";
    }
    const percentage = (totalSeconds / maxTotalSeconds) * 100;
    return percentage.toFixed(2) + "%";
  }

  getTotalTime(timeArray) {
    if (!timeArray || timeArray.length === 0) {
      return "00:00:00";
    }
    const totalSeconds = timeArray.reduce((total, time) => {
      if (!time) return total;
      const [hours, minutes, seconds] = time.split(':').map(Number);
      return total + hours * 3600 + minutes * 60 + seconds;
    }, 0);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    return `${this.padZeroes(hours)}:${this.padZeroes(minutes)}:${this.padZeroes(remainingSeconds)}`;
  }

  padZeroes(value: number) {
    return value.toString().padStart(2, '0');
  }

  findMaxTime(timeArray) {
    if (timeArray.length === 0) {
      return "00:00:00";
    }
    let maxTime = "00:00:00";
    for (const timeString of timeArray) {
      const [hours, minutes, seconds] = timeString.split(":").map(Number);
      const totalSeconds = hours * 3600 + minutes * 60 + seconds;
      const [maxHours, maxMinutes, maxSeconds] = maxTime.split(":").map(Number);
      const maxTotalSeconds = maxHours * 3600 + maxMinutes * 60 + maxSeconds;
      if (totalSeconds > maxTotalSeconds) {
        maxTime = timeString;
      }
    }
    return maxTime;
  }

  getDotStyle(index: number) {
    return {
      width: '14px',
      height: '14px',
      backgroundColor: this.BarColor[index],
      textAlign: 'end',
      borderRadius: '50%',
    };
  }

  getUsagePercentage(item: any): string {
    return item.usagePercentage || "0%";
  }
}
